export const calendarDayLabel = (day: number) => {
  if (day === 1) return 'First day'
  if (day === 7) return 'Last day'
  return `Day ${day}`
}
